import { useSelector } from "react-redux";
import { IMediaCategoryListModel } from "../models";
import { IAppState } from "../store";

export const useMediaCategoriesSelector = () => {
  return useSelector<IAppState, IMediaCategoryListModel>(
    (state) => state.media.mediaCategories
  );
};
